import cn from 'classnames'
import { FC } from 'react'

import { Button } from 'core-components/library/button'
import { TableMode } from 'core-components/library/list/types'

import { IContactListViewModeProps } from './models'

import styles from './ContactListViewMode.module.scss'

export const ContactListViewMode: FC<IContactListViewModeProps> = ({ onChangeViewMode }) => (
  <div className={styles.headerActions}>
    <Button
      className={styles.headerAction}
      variant={'text'}
      color={'grey'}
      iconButton={cn(styles.headerAction__icon, 'hpicon hpicon-th')}
      onClick={() => onChangeViewMode(TableMode.div)}
    />
    <Button
      className={styles.headerAction}
      variant={'text'}
      color={'grey'}
      iconButton={cn(styles.headerAction__icon, 'hpicon hpicon-list')}
      onClick={() => onChangeViewMode(TableMode.table)}
    />
  </div>
)
